export default __webpack_public_path__ + "static/media/plus-icon.85bf5cb2.svg";